export type DateTimePrecision = 'minute' | 'second';

const minuteFormatter = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const secondFormatter = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'medium' });

export function formatDateTime(
  value: string,
  precision: DateTimePrecision = 'minute',
  nowMilliseconds: number = Date.now(),
): string {
  const timestamp = new Date(value);
  const formatter = precision === 'second' ? secondFormatter : minuteFormatter;
  return `${formatter.format(timestamp)} ${formatRelativeAge(timestamp, nowMilliseconds)}`;
}

export function formatRelativeAge(timestamp: Date, nowMilliseconds: number = Date.now()): string {
  const differenceMilliseconds = nowMilliseconds - timestamp.getTime();
  const elapsed = formatElapsedAge(Math.abs(differenceMilliseconds));
  return differenceMilliseconds < 0 ? `(in ${elapsed})` : `(${elapsed} ago)`;
}

function formatElapsedAge(milliseconds: number): string {
  const totalMinutes = Math.floor(milliseconds / 60_000);
  if (totalMinutes < 1) {
    return '<1m';
  }
  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }

  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 6) {
    const remainingMinutes = totalMinutes % 60;
    return remainingMinutes === 0 ? `${totalHours}h` : `${totalHours}h ${remainingMinutes}m`;
  }
  if (totalHours < 24) {
    return `${totalHours}h`;
  }

  const totalDays = Math.floor(totalHours / 24);
  if (totalDays < 3) {
    const remainingHours = totalHours % 24;
    return remainingHours === 0 ? `${totalDays}d` : `${totalDays}d ${remainingHours}h`;
  }
  return `${totalDays}d`;
}
